import { render, staticRenderFns } from "./submit-card.vue?vue&type=template&id=f76e234c"
import script from "./submit-card.vue?vue&type=script&lang=js"
export * from "./submit-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports